export const DraggableItemTypes = {
  MEMBER_PROFILE_ICON: "member profile icon",
  USER_PROFILE_ICON: "user profile icon",
}
